import { render, staticRenderFns } from "./aboutus.vue?vue&type=template&id=0bbdadaa&scoped=true&"
import script from "./aboutus.vue?vue&type=script&lang=js&"
export * from "./aboutus.vue?vue&type=script&lang=js&"
import style0 from "./aboutus.vue?vue&type=style&index=0&id=0bbdadaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbdadaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bbdadaa')) {
      api.createRecord('0bbdadaa', component.options)
    } else {
      api.reload('0bbdadaa', component.options)
    }
    module.hot.accept("./aboutus.vue?vue&type=template&id=0bbdadaa&scoped=true&", function () {
      api.rerender('0bbdadaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/aboutus.vue"
export default component.exports